import { render, staticRenderFns } from "./WhatsappTemplate.vue?vue&type=template&id=43c2fbd4&"
import script from "./WhatsappTemplate.vue?vue&type=script&lang=ts&"
export * from "./WhatsappTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports